import axios from 'axios';

const apiRoot = process.env.REACT_APP_API_ROOT;
/**
 * REST APIリクエストを送信するクラス
 */
export class ApiFetcher {
  private static basicAxios = axios.create({
    baseURL: apiRoot,
  });

  /**
   * GET APIリクエストを送信します。
   * @param path パス
   * @param params クエリパラメータ
   */
  async get(path: string, params: any = undefined): Promise<any> {
    const response = await ApiFetcher.basicAxios.get(path, {
      params: params
    });
    return response.data;
  }

  /**
   * POST APIリクエストを送信します。
   * @param path 
   * @param data 
   */
  async post(path: string, data: any): Promise<any> {
    const response = await ApiFetcher.basicAxios.post(path, data);
    
    return response.data;
  }

  /**
   * PUT APIリクエストを送信します。
   * @param path 
   * @param data 
   */
  async put(path: string, data: any): Promise<any> {
    const response = await ApiFetcher.basicAxios.put(path, data);

    return response.data;
  }

  /**
   * DELETE APIリクエストを送信します。
   * @param path 
   * @param data 
   */
  async delete(path: string): Promise<any> {
    const response = await ApiFetcher.basicAxios.delete(path);

    return response.data;
  }
}